import { canv } from '@/canv/global.js'

export class shapePentagon {

    constructor() {

    }


    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width * 3/5 - 2 * horizontalPadding;
        var allowedHeight = height * 8/10 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.startY = y + height * 2/10 + height * 8/10 / 2  - textPart.height / 2 + textPart.lines[0].textHeight;


        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height * 4 / 10);
        canv.ctx.lineTo(x + width * 2/10, y + height);
        canv.ctx.lineTo(x + width * 8/10, y + height);
        canv.ctx.lineTo(x + width, y + height * 4/10);
        canv.ctx.lineTo(x + width/2, y);
        canv.ctx.lineTo(x, y + height * 4/10);
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38.0794 1.60046L1.6092 31.9923C0.642558 32.7979 0.281319 34.121 0.704526 35.306L15.9556 78.009C16.382 79.203 17.513 80 18.7808 80H61.2192C62.487 80 63.618 79.203 64.0444 78.009L79.2955 35.306C79.7187 34.121 79.3574 32.7979 78.3908 31.9923L41.9206 1.60046C40.808 0.673346 39.192 0.673345 38.0794 1.60046Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0794 1.60046L1.6092 8.659C0.642558 9.46453 0.28132 10.7877 0.704527 11.9727L4.28893 22.009C4.71535 23.203 5.84632 24 7.11416 24H16.8858C18.1537 24 19.2846 23.203 19.7111 22.009L23.2955 11.9727C23.7187 10.7877 23.3574 9.46454 22.3908 8.659L13.9206 1.60046C12.808 0.673346 11.192 0.673345 10.0794 1.60046Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
